"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToastDirection = void 0;
var ToastDirection;
(function (ToastDirection) {
    ToastDirection["TOPDOWN"] = "topDown";
    ToastDirection["DOWNTOP"] = "downTop";
})(ToastDirection = exports.ToastDirection || (exports.ToastDirection = {}));
//# sourceMappingURL=ToastContainerProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/ToastContainer/ToastContainerProps.js
// module id = 1282
// module chunks = 8